/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'
import { Paper, Typography, Button, CircularProgress, InputLabel, MenuItem, FormControl, FormHelperText, Select, TextField } from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete';

import Actions from '../../../fluid/Actions/ActionFactory'

const { listTimeZones } = require('timezone-support')

const blue_theme = createMuiTheme({
    palette: {
        primary: {
          main: '#2296f3',
        },
        secondary: {
          main: '#ff9100',
        },
      },
})

const styles = theme => ({

})

class SetTemporalField extends Component {
    state = {
        fields : null,
        fields_loading : false,
        fields_error : false,
        temp_field : null,
        time_zone : null,
        submit_load : false,
        submit_err : null
    }

    heading = React.createRef()
    footer = React.createRef()

    componentWillMount () {
        this.setState({...this.state, fields_loading : true, fields_error : false}, () => {
            Actions('http_request', {
                url : '/sainapse/information_channel/' + this.props.ic_name + '/information_unit/' + this.props.iu_name + '/field_in_scope',
                method : 'get',
                data : {}
            }).then(res => {
                this.setState({
                    ...this.state,
                    fields : res.data.result.map(field => field.name),
                    fields_loading : false,
                    fields_error : false
                }, () => console.log('Temporal Field in scope:', this.state.fields))
            }).catch(err => {
                this.setState({
                    ...this.state,
                    fields : null,
                    fields_loading : false,
                    fields_error : true
                })
            })
        })
    }

    componentDidMount () {
        const headingHeight = this.heading.current.clientHeight
        const footerHeight = this.footer.current.clientHeight
        const contentHeight = this.props.maxHeight - headingHeight - footerHeight

        this.setState({...this.state, content_height : contentHeight, heading_height : headingHeight})
    }

    componentDidUpdate (prevProps, prevState) {
        console.log('Did Update')
        if (prevProps.maxHeight === null && this.props.maxHeight !== null) {
            const headingHeight = this.heading.current.clientHeight
            const footerHeight = this.footer.current.clientHeight
            const contentHeight = this.props.maxHeight - headingHeight - footerHeight
            console.log('Max Height IU: ', this.props.maxHeight)
            console.log('Head Height :', headingHeight)
            console.log('Content Height IU :', contentHeight)
            this.setState({...this.state, content_height : contentHeight, heading_height : headingHeight})
        }
    }

    renderContent = () => {
        if (this.state.fields_loading) {
            return (
                <ThemeProvider theme = {blue_theme}>
                    <CircularProgress/>
                </ThemeProvider>
            )
        } else {
            if (this.state.fields_error) {
                return (
                    <Fragment>
                        <Typography>Error retreiving fields in scope</Typography>
                    </Fragment>
                )
            } else {
                return (
                    <Fragment>
                        <div style = {{width : '50%', padding : '10px', borderBottom : '1px solid rgba(0,0,0,0.12)'}}>
                            <Typography variant = 'body2' color = 'textSecondary' align = 'center'>Please select the temporal field of the record that has to be considered during data transfer. Also select the time zone to be considered for this temporal field.</Typography>
                        </div>
                        <div style = {{width : '50%', marginTop : '10px'}}>
                            <ThemeProvider theme = {blue_theme}>
                                <Paper square elevation = {5} style = {{width : '100%', display : 'flex', flexDirection : 'row'}}>
                                    {this.renderFieldSelect()}
                                    {this.renderTZSelect()}
                                </Paper>
                            </ThemeProvider>
                        </div>
                    </Fragment>
                )
            }
        }
    }

    updateState = (key, value) => {
        this.setState({
            [key] : value
        })
    }

    renderFieldSelect = () => {
        return (
            <div style = {{width : '50%'}}>
                <div style = {{padding : '10px'}}>
                    <FormControl
                        variant = 'standard' 
                        margin = 'dense'
                        error = {this.state.error}
                        disabled = {this.props.disabled}
                        fullWidth
                    >
                        <InputLabel>Temporal Field</InputLabel>
                        <Select
                            value = {this.state.value}
                            onChange = {(event) => this.updateState('temp_field', event.target.value)}
                        >   
                            {this.state.fields.map(field => {
                                return (
                                    <MenuItem value = {field}>{field}</MenuItem>
                                )
                            })}
                        </Select>
                        <FormHelperText>Select the temporal field</FormHelperText>
                    </FormControl>
                </div>
            </div>
        )
    }

    renderTZSelect = () => {
        return (
            <div style = {{width : '50%'}}>
                <div style = {{padding : '10px'}}>
                    <Autocomplete
                        value = {this.state.time_zone}
                        onChange = {(event, newValue) => this.updateState('time_zone', newValue)}
                        options={listTimeZones()}
                        getOptionLabel={(option) => option}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="standard"
                                margin = 'dense'
                                label= "Time Zone"
                                placeholder= "Canonical Time Zone Name"
                                helperText = "Select the time zone"
                            />
                        )}
                    />
                </div>
            </div>
        )
    }

    submitTemporalField = () => {
        this.setState({...this.state, submit_load : true}, () => {
            Actions('http_request', {
                url : '/sainapse/information_channel/' + this.props.ic_name + '/information_unit/' + this.props.iu_name + '/temporal_field',
                method : 'post',
                data : {
                    name : this.state.temp_field,
                    time_zone : this.state.time_zone
                }
            }).then(res => {
                this.setState({...this.state, submit_load : false, submit_err : null}, () => this.props.handleNext())
            }).catch(err => {
                let error = err.response.data
                this.setState({...this.state, submit_load : false, submit_err : error.message})
            })
        })
    }

    render() { 
        return (
                <Paper elevation = {0} square style = {{width : '100%', height : '100%'}}>
                    <div style = {{width : '100%', height : '100%'}}>
                        <div 
                            ref = {this.heading} 
                            style = {{
                                display : 'flex', 
                                flexDirection : 'row', 
                                alignItems : 'center',
                                alignContent : 'flex-end',
                                backgroundColor : '#F0F0F0',
                                borderBottom : '1px solid rgba(0,0,0,0.12)',
                                padding : '8px'
                            }}>
                            <Typography variant='h6' style = {{flexGrow : 1}}>Set Temporal Field</Typography>
                            <Typography style = {{color : '#F50157'}} variant = 'caption'>{this.state.submit_err}</Typography>
                        </div>
                        <div
                            style = {{
                                width : '100%',
                                height: this.state.content_height,
                                display : 'flex',
                                flexDirection : 'column',
                                justifyContent : 'center',
                                alignItems : 'center'
                            }}
                        >
                            {this.renderContent()}
                        </div>
                        <div ref = {this.footer} 
                            style = {{
                                display : 'flex', 
                                flexDirection : 'row-reverse',
                                backgroundColor : '#F0F0F0',
                                padding : '8px',
                                borderTop : '1px solid rgba(0,0,0,0.12)',
                            }}>
                                <ThemeProvider theme = {blue_theme}>
                                    <Button
                                        variant = 'contained'
                                        color = 'primary'
                                        size = 'small'
                                        // disabled = {this.state.temp_field !== null && this.state.time_zone !== null ? false : true}
                                        onClick = {this.submitTemporalField}
                                        startIcon = {this.state.submit_load ? <CircularProgress style = {{color : '#FFFFFF'}} size = {20}/> : null}
                                    >
                                        Next
                                    </Button>
                                </ThemeProvider>
                        </div>
                    </div> 
                </Paper>
        );
    }
}
 
export default withStyles(styles)(SetTemporalField);